// extracted by mini-css-extract-plugin
export default {"root":"InvestorEligibilityManagementPage_root__FShmO","disabledCheckbox":"InvestorEligibilityManagementPage_disabledCheckbox__+2C3L"};